import Vue from 'vue'
import VueRouter from 'vue-router'
import auth from '@auth'

// eslint-disable-next-line import/no-cycle
import store from '@/store'
import { LIST_URL_REDIRECT } from '@/constants'
import { setCookie } from '@/libs/common'
import authRoute from './routes/auth'
import dashboardRoute from './routes/dashboard'
import paymentRoute from './routes/payment'
import errorRoute from './routes/error'
import adsAccount from './routes/adsAccount'
import billing from './routes/billing'
import pricing from './routes/pricing'
import partnerManagement from './routes/partnerManagement'
import referralProgram from './routes/referralProgram'
import pixelManagement from './routes/pixelManagement'
import referralProgramNew from './routes/referralProgramsNew'
import podyRoute from './routes/pody'

Vue.use(VueRouter)

const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

const router = new VueRouter({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    ...authRoute,
    ...dashboardRoute,
    ...paymentRoute,
    ...errorRoute,
    ...adsAccount,
    ...(pricing && process.env.VUE_APP_MODE_SUBSCRIPTION === 'true' ? pricing : []),
    ...(billing && process.env.VUE_APP_MODE_SUBSCRIPTION === 'true' ? billing : []),
    ...partnerManagement,
    ...(referralProgram && process.env.VUE_APP_MODE_REF === 'true' ? referralProgram : []),
    ...(pixelManagement && process.env.VUE_APP_MODE_PIXEL === 'true' ? pixelManagement : []),
    ...(referralProgramNew && process.env.VUE_APP_PARTNERO_ID ? referralProgramNew : []),
    ...(podyRoute && process.env.VUE_APP_PLATFORM_NAME === 'Ecomdy' ? podyRoute : []),
  ],
})

// ? For splash screen

router.beforeEach(async (to, from, next) => {
  /* --- this code check auto login for shopify ---*/
  const { query } = to
  const { session } = query
  let sessionData
  if (session) {
    sessionData = JSON.parse(atob(session))
  }

  const idToken = query.id_token ?? sessionData?.id_token
  const loginUrl = process.env.VUE_APP_LOGIN_URL

  if (idToken) {
    localStorage.setItem('id_token', idToken)
    setCookie(to)
    delete query.id_token
    delete query.session

    next({ path: to.path, query, replace: true })
  }

  /* --- this code check auto login for shopify ---*/
  if (!idToken && loginUrl && LIST_URL_REDIRECT.some(record => record === to.path)) {
    window.location.href = `${loginUrl}${to.fullPath}`
    // eslint-disable-next-line consistent-return
    return next()
  }

  await store.dispatch('auth/setIsAuthenticated', !!auth.getToken())

  // this page required not logged in to access, ex: login, register, reset, forgot password, v..v
  const requireNotAuth = await to.matched.some(record => record.meta.requireNotAuth)

  // redirect to login page if not logged in and trying to access a restricted page
  const requireAuth = await to.matched.some(record => record.meta.requireAuth)

  // this page require has plan
  // const requireUpdateInfo = await to.matched.some(record => record.meta.requireUpdateInfo)
  if (store.getters['auth/isAuthenticated']) {
    if (window !== window.top) {
      auth.clearLocalStorage()
      next({ name: 'register' })
    } else if (requireNotAuth && to.name !== 'reset-password') {
      next({ name: 'dashboard', replace: true })
    }
  } else if (requireAuth) {
    if (loginUrl) {
      window.location.href = `${loginUrl}/logout`
    } else {
      next({ name: 'login', query: { redirect: to.fullPath } })
    }
  }

  // eslint-disable-next-line consistent-return
  return next()
})

// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
